export default __webpack_public_path__ + "static/media/DeliverySelected.fe6d30d4.svg";